import { RegularHistoryAcceptActivityPayCheckPage } from "@/features/regular-document/pages/acceptance-activity-document/RegularHistoryAcceptActivityPayCheck";

const RegularHistoryAcceptanceActivityPayCheck = () => {
  return <RegularHistoryAcceptActivityPayCheckPage />;
};

export default RegularHistoryAcceptanceActivityPayCheck;
